var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "author-metadata" }, [
    _c("div", { staticClass: "row title" }, [_vm._t("head")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-12 journal-section content-padding" },
        [_vm._t("main")],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }